import { MutableRefObject, useEffect } from 'react';

export function useOutsideClickDetection(
  ref: MutableRefObject<any> | MutableRefObject<any>[],
  onOutsideClick: () => any,
) {
  useEffect(() => {
    function handleClickOutside(event: Event) {
      if (Array.isArray(ref)) {
        if (
          ref.every((r) => r.current) &&
          !ref.some((r) => r.current.contains(event.target))
        ) {
          onOutsideClick();
        }
      } else if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onOutsideClick]);
}
